<template>
  <div>
    <b-form class="hc-modern-form" @submit.stop.prevent="submitData">
      <div class="row no-gutters mx-n1">
        <!-- Date Picker -->
        <div class="col-lg-6 col-12 px-1">
          <b-form-group
            id="input-group-date"
            label="Dari Tgl:"
            label-for="input-date"
          >
            <b-input-group>
              <b-input-group-prepend>
                <b-form-datepicker
                  locale="id"
                  placeholder="Tanggal Mulai"
                  id="input-date"
                  v-model="form.start_date"
                  button-only
                  aria-controls="example-input"
                ></b-form-datepicker>
              </b-input-group-prepend>
              <b-form-input
                id="input-date"
                v-model="form.start_date"
                type="text"
                placeholder="YYYY-MM-DD"
                @input="formaterDate"
              ></b-form-input>
              <small class="text-danger">{{ error.start_date }}</small>
            </b-input-group>
          </b-form-group>
        </div>

        <!-- Date Picker -->
        <div class="col-lg-6 col-12 px-1">
          <b-form-group
            id="input-group-date"
            label="Tanggal Selesai:"
            label-for="input-date-end"
          >
            <b-input-group>
              <b-input-group-prepend>
                <b-form-datepicker
                  locale="id"
                  placeholder="Tanggal"
                  v-model="form.end_date"
                  button-only
                  aria-controls="example-input"
                ></b-form-datepicker>
              </b-input-group-prepend>
              <b-form-input
                id="input-date-end"
                v-model="form.end_date"
                type="text"
                placeholder="YYYY-MM-DD"
                @input="formaterDateEnd"
              ></b-form-input>
              <small class="text-danger">{{ error.end_date }}</small>
            </b-input-group>
          </b-form-group>
        </div>
      </div>

      <!-- Name input -->
      <b-form-group id="input-group-name" label="Nama:" label-for="input-name">
        <b-form-input
          id="input-name"
          v-model="form.name"
          placeholder="Nama Promo"
        ></b-form-input>
        <small class="text-danger">{{ error.name }}</small>
      </b-form-group>

      <div class="row">
        <div class="col-md-4">
          <!-- Input Jenis -->
          <b-form-group
            id="input-group-status"
            label="Jenis Potongan:"
            label-for="input-status"
          >
            <b-form-select
              id="input-status"
              v-model="form.is_percent"
              :options="type"
              @change="setType(form.is_percent)"
            ></b-form-select>
            <small class="text-danger">{{ error.is_percent }}</small>
          </b-form-group>
        </div>
        <div class="col-md-4">
          <b-form-group
            id="input-group-name"
            label="Besar Potongan:"
            label-for="input-name"
          >
            <b-input-group :prepend="type_value" class="">
              <b-form-input
                id="input-amount"
                v-model="formatedAmount"
                inputmode="numeric"
                placeholder="Besar Potongan"
              ></b-form-input>
            </b-input-group>
            <small class="text-danger">{{ error.amount }}</small>
          </b-form-group>
        </div>
        <div class="col-md-4">
          <b-form-group label="Maksimal Potongan:" label-for="promo-max-amount">
            <b-input-group prepend="Rp"><b-form-input id="promo-max-amount" v-model="formatedMaxAmount" inputmode="numeric" placeholder="Tanpa batas" :disabled="form.is_percent == 0"></b-form-input></b-input-group>
            <small class="text-muted">Plafon biaya untuk diskon persentase.</small>
            <small class="text-danger d-block">{{ error.max_amount }}</small>
          </b-form-group>
        </div>
      </div>

      <div class="hc-promotion-switches">
        <b-form-checkbox v-model="form.is_active" :value="true" :unchecked-value="false" switch><strong>Program aktif</strong><small>Diskon diterapkan selama periode berlaku.</small></b-form-checkbox>
        <b-form-checkbox v-model="form.is_stackable" :value="true" :unchecked-value="false" switch><strong>Boleh digabung kupon</strong><small>Izinkan diskon item dipakai bersama kupon transaksi.</small></b-form-checkbox>
      </div>

      <hr />

      <section class="hc-form-section">
        <h5 class="hc-form-section-title">Target & Prioritas Otomatis</h5>
        <div class="row"><div class="col-md-4"><b-form-group label="Prioritas"><b-form-input v-model.number="form.priority" type="number" min="0"></b-form-input></b-form-group></div><div class="col-md-4"><b-form-group label="Jam mulai"><b-form-input v-model="form.valid_start_time" type="time"></b-form-input></b-form-group></div><div class="col-md-4"><b-form-group label="Jam selesai"><b-form-input v-model="form.valid_end_time" type="time"></b-form-input></b-form-group></div></div>
        <b-form-group label="Kanal transaksi"><b-form-checkbox-group v-model="form.service_channels" :options="channelOptions"></b-form-checkbox-group><small class="text-muted">Kosong berarti semua kanal.</small></b-form-group>
        <b-form-group label="Cabang/tenant sasaran"><b-form-tags v-model="form.branch_ids" separator=" ,;" placeholder="Ketik kode cabang lalu Enter"></b-form-tags><small class="text-muted">Kosong berarti berlaku untuk seluruh cabang/tenant.</small></b-form-group>
        <b-form-group label="Segmen pasien"><b-form-checkbox-group v-model="form.patient_segments" :options="segmentOptions"></b-form-checkbox-group></b-form-group>
        <b-form-group label="Hari berlaku"><b-form-checkbox-group v-model="form.days_of_week" :options="dayOptions"></b-form-checkbox-group></b-form-group>
        <b-form-group label="Metode pembayaran"><div v-if="loadingPaymentMethods" class="text-muted py-2"><span class="spinner-border spinner-border-sm mr-2"></span>Memuat metode pembayaran...</div><b-form-checkbox-group v-else v-model="form.payment_method_ids" :options="paymentMethodOptions"></b-form-checkbox-group><small class="text-muted">Kosong berarti berlaku untuk semua metode pembayaran.</small></b-form-group>
      </section>

      <PromotionTargetManager v-model="form.targets" :promo-id="promoId" />

      <!-- Description input -->
      <b-form-group id="input-group-description">
        <label for="input-description"
          >Deskripsi : <em class="text-muted">opsional</em></label
        >
        <b-form-textarea
          id="input-description"
          v-model="form.description"
          placeholder="Deksripsi"
          rows="4"
          max-rows="8"
        ></b-form-textarea>
        <small class="text-danger">{{ error.description }}</small>
      </b-form-group>

      <!-- Submit & Cancel button -->
      <b-button type="submit" variant="primary" :disabled="saving"><span v-if="saving" class="spinner-border spinner-border-sm mr-2"></span>Simpan promo</b-button>
      <b-button
        type="button"
        class="ml-2"
        variant="default"
        @click="$router.push('/masters/promos')"
      >
        Batal
      </b-button>
    </b-form>
  </div>
</template>

<script>
import module from "@/core/modules/CrudModule.js";
import validation from "@/core/modules/ValidationModule.js";
import PromotionTargetManager from "./PromotionTargetManager.vue";

export default {
  components: { PromotionTargetManager },
  props: {
    form: Object,
    route: String,
  },

  data() {
    return {
      // type coupon
      type: [
        {
          text: "Nominal (Rp)",
          value: 0,
        },
        {
          text: "Persen (%)",
          value: 1,
        },
      ],
      type_value: "Rp",
      channelOptions: [{text:"Rawat jalan & kasir klinik",value:"clinic"},{text:"Apotek",value:"pharmacy"},{text:"Rawat inap",value:"inpatient"},{text:"Home Care",value:"home_care"}],
      segmentOptions: [{text:"Pasien baru",value:"new"},{text:"Pasien lama",value:"returning"}],
      dayOptions: [{text:"Sen",value:1},{text:"Sel",value:2},{text:"Rab",value:3},{text:"Kam",value:4},{text:"Jum",value:5},{text:"Sab",value:6},{text:"Min",value:7}],
      // Error
      saving: false,
      loadingPaymentMethods: false,
      paymentMethodOptions: [],
      error: {
        name: "",
        is_percent: "",
        start_date: "",
        end_date: "",
        amount: "",
        max_amount: "",
        description: "",
      },
    };
  },

  computed: {
    promoId() { const match=String(this.route||"").match(/promos\/(\d+)/);return match?match[1]:null; },
    formatedAmount: {
      set(newValue) {
        newValue = parseInt(newValue.replace(/\D/g, ""), 10);
        if (!Number.isNaN(newValue)) {
          this.form.amount = newValue.toLocaleString("id-ID");
        } else {
          this.form.amount = 0;
        }
      },
      get() {
        return this.form.amount;
      },
    },
    formatedMaxAmount: {
      set(newValue) {
        newValue = parseInt(newValue.replace(/\D/g, ""), 10);
        if (!Number.isNaN(newValue)) {
          this.form.max_amount = newValue.toLocaleString("id-ID");
        } else {
          this.form.max_amount = 0;
        }
      },
      get() {
        return this.form.max_amount;
      },
    },
  },

  methods: {
    submitData() {
      if (this.form.is_percent == 1) {
        if (Number(String(this.form.amount).replace(/\D/g, "")) > 100) {
          Swal.fire(
            "Perhatian",
            "Besaran Potongan Promo tidak boleh lebih dari 100%",
            "warning"
          );
        } else {
          this.formOnsubmit();
        }
      } else {
        this.formOnsubmit();
      }
    },

    async formOnsubmit() {
      this.saving = true;
      // Make Request
      let response = await module.submit(this.form, this.route);
      // Check Response
      if (response.state == "error") {
        // Validation Error
        this.error = validation.setValidationError(
          this.error,
          response.error.errors
        );
      } else {
        const promoId = this.promoId || this.extractId(response.success && response.success.item);
        if (!promoId) {
          this.saving = false;
          return Swal.fire("Gagal", "Promo tersimpan, tetapi target belum dapat dikaitkan. Silakan buka kembali promo ini.", "warning");
        }
        const targetResponse = await module.submit({_method:"put",targets:(this.form.targets||[]).map(x=>({type:x.type,id:x.id}))}, `marketing-governance/promos/${promoId}/targets`);
        if(targetResponse.state === "error") {
          this.saving = false;
          return Swal.fire("Target belum tersimpan", targetResponse.error.message || "Periksa pilihan target lalu coba kembali.", "warning");
        }
        // Success
        Swal.fire(response.success.title, response.success.message, "success");
        this.$router.push("/masters/promos/list");
      }
      this.saving = false;
    },

    extractId(value) { if(!value||typeof value!=="object")return null;if(value.id)return value.id;for(const key of Object.keys(value)){const found=this.extractId(value[key]);if(found)return found;}return null; },

    setType(data) {
      if (data == 0) {
        this.type_value = "Rp";
        this.form.max_amount = 0;
      } else {
        this.type_value = "%";
      }
    },
    formaterDate(val) {
      if (val.length == 4) {
        this.form.start_date = this.form.start_date + "-";
      }
      if (val.length == 7) {
        this.form.start_date = this.form.start_date + "-";
      }
    },

    formaterDateEnd(val) {
      if (val.length == 4) {
        this.form.end_date = this.form.end_date + "-";
      }
      if (val.length == 7) {
        this.form.end_date = this.form.end_date + "-";
      }
    },
  },

  async mounted() {
    this.loadingPaymentMethods = true;
    const methods = await module.setSelectOption("payment-methods");
    this.paymentMethodOptions = methods.state === "success" ? methods.data : [];
    this.loadingPaymentMethods = false;
    if (this.form.is_percent == 1) {
      this.type_value = "%";
      this.form.max_amount = parseInt(this.form.max_amount || 0).toLocaleString("id-ID");
    } else {
      this.type_value = "Rp";
      if (this.form.amount != "") {
        this.form.amount = parseInt(this.form.amount).toLocaleString("id-ID");
      }
    }
  },
};
</script>

<style scoped>
.hc-promotion-switches { display: grid; grid-template-columns: repeat(2, minmax(0, 1fr)); gap: 12px; margin: 4px 0 18px; padding: 14px; border: 1px solid #e4eaf1; border-radius: 12px; background: #f8fafc; }
.hc-promotion-switches small { display: block; margin-left: 24px; color: #7b8797; font-size: 10px; }
@media (max-width: 767px) { .hc-promotion-switches { grid-template-columns: 1fr; } }
</style>
